/**
 * Simple Error Logger - Direct Console Output
 * All errors are logged directly to console for development visibility
 */

export class ErrorLogger {
  constructor(context = 'App') {
    this.context = context;
    this.sessionId = this.generateSessionId();
  }

  generateSessionId() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }

  /**
   * Log an error directly to console
   */
  logError(error, additionalContext = {}, severity = 'medium') {
    console.group(`🚨 ${this.context} Error [${severity.toUpperCase()}]`);
    console.error('Error:', error);
    console.log('Context:', additionalContext);
    console.log('Session ID:', this.sessionId);
    console.groupEnd();
  }

  /**
   * Log performance metrics directly to console
   */
  logPerformance(metric, value, additionalData = {}) {
    console.log(`📊 ${this.context} Performance: ${metric} = ${value}`, additionalData);
  }

  /**
   * Log user actions directly to console
   */
  logUserAction(action, data = {}) {
    console.log(`👤 ${this.context} Action: ${action}`, data);
  }
}

// Create a singleton instance for profile setup
export const profileSetupLogger = new ErrorLogger('ProfileSetup');

// Helper functions for common use cases
export const logProfileError = (error, step, additionalContext = {}) => {
  console.group(`🚨 ProfileSetup Error [Step ${step}]`);
  console.error('Error:', error);
  console.log('Additional Context:', additionalContext);
  console.groupEnd();
};

export const logProfileAction = (action, step, data = {}) => {
  console.log(`👤 ProfileSetup Action [Step ${step}]: ${action}`, data);
};

export const logProfilePerformance = (metric, value, step, additionalData = {}) => {
  console.log(`📊 ProfileSetup Performance [Step ${step}]: ${metric} = ${value}ms`, additionalData);
};
